/*
 *  Navigation Call Out
 *    Superclass for any carousel section you build, provides nice defaults that
 *    can be provided as data attributes from the wrapped container.
 *
 *  Version:
 *    1.0.0 - 2019/11/18
 */

import $ from 'jquery';
import 'slick-carousel';

import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-nav-callout]';
export const CAROUSEL_SELECTOR = '[data-nav-callout-carousel]';
export const NAV_BUTTON = '[data-nav-callout-button]';
export const DATA_NAV_BUTTON = 'data-nav-callout-button';
export const DATA_IMAGE = 'data-nav-callout-image';

// class
export const CLASS_ACTIVE = 'is-active';
export const CLASS_PRECLICK = 'pre-click';

export class FeaturedReviews extends CarouselSection {
  constructor(container) {
    super(container);

    this.container = container;

    // carousel
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    this.slick = this.initCarousel(this.carouselContainer);

    this.allNavButton = container.find(NAV_BUTTON);
    this.allImages = container.find('['+DATA_IMAGE+']');


    this.container.on('mouseenter', NAV_BUTTON, e => this.onHoverNav(e));
    this.container.on('click touchend', NAV_BUTTON, e => this.onClickNav(e));
  }

  onClickNav(e){
    e.stopPropagation();
    e.preventDefault();

    let self = $(e.currentTarget);
    let link = self.attr('href');

    window.location = link;
  }

  onHoverNav(e){
    // e.stopPropagation();
    // e.preventDefault();

    let self = $(e.currentTarget);
    let targetID = self.attr(DATA_NAV_BUTTON);
    let targetImg = this.container.find('['+DATA_IMAGE+'='+targetID+']')

    this.allImages.removeClass(CLASS_ACTIVE);
    this.allImages.removeClass(CLASS_PRECLICK);
    this.allImages.fadeOut(50)
    this.allNavButton.removeClass(CLASS_ACTIVE);

    if(!self.hasClass(CLASS_ACTIVE)){
      self.addClass(CLASS_ACTIVE);
    }

    if(!targetImg.hasClass(CLASS_ACTIVE)){
      targetImg.addClass(CLASS_ACTIVE);
      targetImg.fadeIn(300)
    }

    console.log(targetID)
  }

  optionOverrides() {
    return {
      infinite: this.carouselContainer.data('infinite') == false ? false : true,
      slidesToShow: this.carouselContainer.data('slides-to-show') || 1,
      slidesToScroll: this.carouselContainer.data('slides-to-scroll') || 1,
      autoplay: this.carouselContainer.data('autoplay') == false ? false : true,
      dots: this.carouselContainer.data('dots') == false ? false : true,
      arrows: this.carouselContainer.data('arrows') == false ? false : true,
      adaptiveHeight: this.carouselContainer.data('adaptiveheight') == false ? false : true,
      autoplaySpeed: this.carouselContainer.data('autoplay-speed') || 5000,
      prevArrow: this.prevButton,
      nextArrow: this.nextButton,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall-1,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        },
        {
          breakpoint: 599,
          settings: { slidesToShow: 2, slidesToScroll: 2 }
        },
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 2, slidesToScroll: 2 }
        },
        {
          breakpoint: 900,
          settings: { slidesToShow: 3, slidesToScroll: 3 }
        }
      ]
    }
  }

}

register(CONTAINER_SELECTOR, FeaturedReviews);